import styled from '@emotion/styled';
import React,{useState} from 'react'
import { useSettingModal } from '../../../../hooks/Context';
import { ModalContainer,IconContainer,UIcon,SubmitContainer,StyleButton } from './CreateAdminUser';
import apiCall from '../../../../utils/apiCall';



const StyledForm = styled.form`
    background-color  :#fff ;
    display:flex;
    flex-direction: column;
    gap:20px;
    padding:20px 30px; 
     & > *{
        width:100%;
     }
`;


const StyledLabel = styled.label`
    display: flex;
    flex-direction: column;
    gap:10px;
`

const StyledInput = styled.input`
    padding:15px;
    border:1px solid #E1E1E1;
    outline:none;
    border-radius: 5px;
`





const CreateClaim = () => {
    const {setShowModal} = useSettingModal()
    const [claimName,setClaimName] = useState<string>('');
    const [claimValue,setClaimValue] = useState<string>('');
    
    const handleSubmit =(e:any)=>{
        e.preventDefault();
        if(claimName && claimValue){
            const apiData = {
                Id:Math.floor(Math.random() * 1000)+1,
                ClaimName:claimName,
                ClainValue:claimValue
            }
            apiCall().post(`/Administration/users/CreateClaimNameAndValues`, apiData)
            .then(data =>{
             
            })
            .catch(err =>{
              
            })
        }
    }
  return (
    <ModalContainer>
         <div>
            <div>
            <div>
                <IconContainer><UIcon /></IconContainer>
                <span>Create Claim</span>
            </div>
            </div>
            <StyledForm onSubmit={handleSubmit}>
                <StyledLabel>
                    <span>Name</span>
                    <StyledInput value={claimName}
                    onChange={(e)=>setClaimName(e.target.value)}
                     type="text" placeholder='Name' />
                </StyledLabel>
                <StyledLabel>
                    <span>Value</span>
                    <StyledInput value={claimValue}
                    onChange={(e)=>setClaimValue(e.target.value)}
                     type="text" placeholder='Value' />
                </StyledLabel>
                <SubmitContainer>
                    <span onClick={()=>setShowModal(false)}>Cancel</span>
                    <StyleButton>Submit</StyleButton>
                </SubmitContainer>
            </StyledForm>
        </div>
    </ModalContainer>
  )
}

export default CreateClaim